module.exports = __webpack_public_path__ + "static/media/banner-phone-CommunityServiceKracow.1ac85c87.jpg";